import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'components/Icon';
import { HiddenInput } from 'components/HiddenInput';
import { ButtonIcon } from 'components/Button';

const TableService = ({
  data,
  opened,
  canChange,
  rentSum,
  handleRemoveComponent,
  handleAddComponent,
  handleUpdateComponent,
  handleRemove,
  handleOpen,
  onUpdate,
  rateVAT,
}) => {
  return (
    <table className="table-instruments">
      <thead>
        <tr className="table-inst-htr">
          <th className="table-inst-th" width="30px">
            №
          </th>
          <th className="table-inst-th" width="16px" style={{ borderRight: 'none', textAlign: 'left' }}></th>
          <th className="table-inst-th" align="start">
            Наименование
          </th>
          <th className="table-inst-th" width="60px">
            Кол-во выдано
          </th>
          <th className="table-inst-th" width="75px">
            Стоим.
          </th>
          {!!rateVAT && (
            <>
              <th className="table-inst-th" width="50px">
                Ставка НДС
              </th>
              <th className="table-inst-th" width="75px">
                Сумма НДС
              </th>
            </>
          )}

          <th className="table-inst-th" width="95px">
            Сумма
          </th>
          <th className="table-inst-th" width="75px"></th>
        </tr>
      </thead>

      <tbody>
        {data &&
          data.map((inst, i) => {
            let icon = 'instrument';

            if (inst.is_priced_by_wear) {
              icon = 'wheel';
            } else if (inst.components && opened.includes(inst.id)) {
              icon = 'tableminus';
            } else if (inst.components && !opened.includes(inst.id)) {
              icon = 'tableplus';
            }

            return (
              <React.Fragment key={inst.id}>
                <tr className="table-inst-tr" onClick={() => handleOpen(inst)}>
                  <th className="table-inst-th text-light">{i + 1}</th>

                  <th className="table-inst-th text-light" style={{ borderRight: 'none', textAlign: 'left' }}>
                    <Icon name={icon} style={{ margin: 'auto' }} />
                  </th>

                  <th className="table-inst-th text-light" align="start">
                    {inst.title}
                  </th>

                  <th className="table-inst-th" width="60px">
                    <HiddenInput
                      canChange={canChange}
                      value={inst.quantity || 0}
                      onChange={(value) => {
                        onUpdate(inst.id, { ...inst, quantity: value });
                      }}
                      min={1}
                    />
                  </th>

                  <th className="table-inst-th" width="75px">
                    <HiddenInput
                      canChange={canChange}
                      value={inst.itemRentSum || 0}
                      postfix=" грн."
                      onChange={(value) => {
                        onUpdate(inst.id, { ...inst, itemRentSum: value });
                      }}
                      min={0}
                    />
                  </th>
                  {!!rateVAT && (
                    <>
                      <th className="table-inst-th" width="50px">
                        {rateVAT}%
                      </th>

                      <th className="table-inst-th" width="75px">
                        {((inst.itemRentSum * inst.quantity) / 100) * rateVAT} грн.
                      </th>
                    </>
                  )}

                  <th className="table-inst-th" width="95px">
                    {inst.itemRentSum * inst.quantity + ((inst.itemRentSum * inst.quantity) / 100) * rateVAT} грн.
                  </th>

                  <th className="table-inst-th">
                    {canChange && (
                      <Icon name="trash" onClick={(e) => handleRemove(inst.id)} style={{ margin: 'auto' }} />
                    )}
                  </th>
                </tr>

                {opened.includes(inst.id) &&
                  inst.components &&
                  inst.components.map((comp) => (
                    <tr key={comp.id} className="table-inst-tr">
                      <th className="table-inst-th text-light"></th>

                      <th className="table-inst-th text-light" style={{ borderRight: 'none', textAlign: 'left' }}></th>

                      <th className="table-inst-th text-light" align="start">
                        {comp.title}
                      </th>

                      <th className="table-inst-th">
                        <HiddenInput
                          canChange={canChange}
                          value={comp.quantity || 0}
                          onChange={(value) => handleUpdateComponent(inst, comp.id, value)}
                        />
                      </th>

                      <th className="table-inst-th" width="75px"></th>
                      <th className="table-inst-th" width="50px"></th>
                      <th className="table-inst-th" width="75px"></th>
                      <th className="table-inst-th" width="95px"></th>

                      <th className="table-inst-th">
                        {canChange && (
                          <Icon
                            name="trash"
                            onClick={(e) => handleRemoveComponent(inst, comp.id)}
                            style={{ margin: 'auto' }}
                          />
                        )}
                      </th>
                    </tr>
                  ))}
                {opened.includes(inst.id) && canChange && (
                  <tr className="table-inst-tr" style={{ padding: '8px' }}>
                    <th className="table-inst-th text-light"></th>
                    <th className="table-inst-th text-light" style={{ borderRight: 'none', textAlign: 'left' }}></th>
                    <th className="table-inst-th text-light" align="start">
                      <ButtonIcon
                        className="btn-add-component"
                        onClick={() => handleAddComponent(inst)}
                        icon="plus"
                        text="Добавить компонент"
                      />
                    </th>

                    <th className="table-inst-th" width="60px"></th>
                    <th className="table-inst-th" width="75px"></th>
                    <th className="table-inst-th" width="50px"></th>
                    <th className="table-inst-th" width="95px"></th>

                    <th className="table-inst-th"> </th>
                  </tr>
                )}
              </React.Fragment>
            );
          })}

        <tr className="table-inst-tr">
          <th className="table-inst-th text-light"></th>

          <th className="table-inst-th text-light" style={{ borderRight: 'none', textAlign: 'left' }}></th>

          <th className="table-inst-th text-light" align="start"></th>

          <th className="table-inst-th" width="50px"></th>

          <th className="table-inst-th" width="75px"></th>

          {!!rateVAT && (
            <>
              <th className="table-inst-th" width="50px"></th>

              <th className="table-inst-th" width="75px">
                {rentSum.tax} грн.
              </th>
            </>
          )}

          <th className="table-inst-th" width="95px">
            {rentSum.itemSum} грн.
          </th>

          <th className="table-inst-th"> </th>
        </tr>
      </tbody>
    </table>
  );
};

TableService.propTypes = {
  data: PropTypes.array,
  opened: PropTypes.array,
  canChange: PropTypes.bool,
  rentSum: PropTypes.object,
  handleRemoveComponent: PropTypes.func,
  handleAddComponent: PropTypes.func,
  handleUpdateComponent: PropTypes.func,
  handleRemove: PropTypes.func,
  handleOpen: PropTypes.func,
  onUpdate: PropTypes.func,
  rateVAT: PropTypes.number,
};

TableService.defaultProps = {
  opened: [],
  canChange: true,
};

export { TableService };
